import { render, staticRenderFns } from "./estadosCargamos.vue?vue&type=template&id=6b6abfd6&scoped=true"
import script from "./estadosCargamos.vue?vue&type=script&lang=js"
export * from "./estadosCargamos.vue?vue&type=script&lang=js"
import style0 from "./estadosCargamos.vue?vue&type=style&index=0&id=6b6abfd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6abfd6",
  null
  
)

export default component.exports